/*eslint-disable*/
export default {
  init() {

    var a = 0;
    $(window).scroll(function () {

      var oTop = $('.home__numbers__item').offset().top - window.innerHeight;
      if (a == 0 && $(window).scrollTop() > oTop) {
        $('.home__numbers__label').each(function () {
          var $this = $(this),
            countTo = $this.attr('data-count');
          $({
            countNum: $this.text()
          }).animate(
            {
              countNum: countTo
            },
            {

              duration: 3000,
              easing: 'swing',
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum);
                //alert('finished');
              }
            }
          );
        });
        a = 1;
      }

    });

    const swiperRace = new Swiper(".c-header__page-race", {
      loop: true,
      slidesPerView: 1,
      direction: "horizontal",
      effect: "fade",
      autoplay: true,
      speed: 500,
      fadeEffect: {
        crossFade: true,
      },
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleRace.js